module.exports = __webpack_public_path__ + "static/Navegando2-bf5988cc3629350c050564936e507b26.png";